export default "__VITE_ASSET__DTEN4FCN__"